import { Form } from 'antd';
import styled from 'styled-components';

export const StyledForm = styled(Form)`
  p {
    font-size: 1.125rem;
    font-weight: inherit;
    margin-bottom: .75rem;
  }
`;

export const VaccinationOptions = styled.div`
  padding: 20px 0;
`;